import React, { FC } from 'react';
import MuiTypography, { TypographyProps as DefaultTypographyProps } from '@mui/material/Typography';
import MuiTooltip from '@mui/material/Tooltip';

export interface TypographyProps {
    children: any;
    gutterBottom?: boolean;
    tooltiop?: string;
    variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h6' | 'body1' | 'body2' | 'caption' | 'subtitle2';
    align?: 'right' | 'left' | 'inherit' | 'center' | 'justify';
    display?: string;
    sx?: DefaultTypographyProps['sx'];
    // component?: DefaultTypographyProps['component'];
    // component?: React.ElementType;
    // component?: React.ElementType<any>;
    component?: React.ElementType<any>;
    showAsTitle?: boolean;
    className?: string;
    onMouseDown?: React.MouseEventHandler<HTMLSpanElement>;
}

const Typography: FC<TypographyProps> = (props: TypographyProps) => {
    const {
        children,
        gutterBottom,
        tooltiop,
        variant,
        align,
        display,
        sx,
        component,
        showAsTitle,
        className,
        onMouseDown,
    } = props;
    const params = {
        children,
        gutterBottom,
        tooltiop,
        variant,
        align,
        display,
        sx,
        component,
        title: showAsTitle ? children : '',
        className,
    };
    const componentRender = (
        <MuiTypography
            {...params}
            onMouseDown={onMouseDown}
            // gutterBottom={gutterBottom}
            // variant={variant || 'body1'}
            // align={align}
            // display={display}
            // sx={sx}
            // component={component || ''}
        >
            {children}
        </MuiTypography>
    );
    if (tooltiop) {
        return <MuiTooltip title={tooltiop}>{componentRender}</MuiTooltip>;
    }

    return componentRender;
};

export default Typography;
